<template>
  <div class="question-view" >
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" @onRenderComplete="mathjaxRes" :safe="false"/>
      </div>
      <div class="choice-list">
        <div class="single" v-for="(its, idx) in choice_option" :key="idx" v-show="!(its.text == '' && its.image == '')">
          <span class="single-letter">{{ letter[idx] }}.</span>
          <span class="single-cte" v-if="its.type == 'text'">
            <vue-mathjax :formula="its.text" @onRenderComplete="mathjaxRes" :safe="false"/>
          </span>
          <img v-else class="single-img" :src="its.image" alt="">
        </div>
      </div>
    </div>
    <div class="quest-img" v-if="form.img_url">
      <img :src="form.img_url" class="img" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: ['form'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      letter,
      choice_option: [],

      useMathjaxNum: 1,
      mathjaxNum: 0,
    }
  },
  methods: {
    mathjaxRes() {
      this.mathjaxNum ++
      // console.log('选择题', this.useMathjaxNum)
      if(this.mathjaxNum >= this.useMathjaxNum) this.$emit('onRenderComplete')
    }
  },
  mounted() {
    let content = JSON.parse(this.form.content)
    // console.log(content)
    this.choice_option = content.choice_option.filter(its => {
      if(its.type == 'text' && its.text.trim() != '') return its
      else if(its.type == 'image' && its.image.trim() != '') return its
    })

    for(let i = 0; i < this.choice_option.length; i++) {
      let its = this.choice_option[i]
      if(its.type == 'text') this.useMathjaxNum ++
    }
  }
}
</script>

<style scoped lang="scss">
.question-view {
  width: 100%;
  height: 100%;
  padding: 0px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    // width: calc(55% - 10px);
    flex: 1;
    height: 100%;
    .title {
      font-size: 15px;
      color: #333;
    }
    .choice-list {
      margin-top: 20px;
      width: calc(55% - 10px);
      padding: 0;
      .single {
        width: 80%;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        border: 2px solid #fcd2ab;
        background-color: #fcd2ab;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        .single-letter {
          font-size: 15px;
          // font-weight: 700;
          margin-right: 5px;
        }
        .single-cte {
          font-size: 13px;
        }
        .single-img {
          width: 80px;
          height: 80px;
          object-fit: contain;
        }

        &:hover {
          opacity: .8;
        }
      }
      .single-select {
        border-color: #d37525;
        background-color: #f8ae64;
      }
    }
  }
  .quest-img {
    width: 300px;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>